/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import _ from 'underscore';

export default (visualizationType :any, measuresCount :number) :boolean => {

    const { requirements } = visualizationType;
    if (!requirements) {
        // no requirements means no violations
        return true;
    }

    const { measures } = requirements;
    if (!measures) {
        // no measures from requirements means no violations
        return true;
    }

    let
        minimumCheckPassed = false,
        maximumCheckPassed = false;

    if (!_.isUndefined(measures.min)) {
        if (Number(measures.min) <= measuresCount) {
            // we should have more measures than minimum needed
            minimumCheckPassed = true;
        }
    } else {
        minimumCheckPassed = true;
    }

    if (!_.isUndefined(measures.max)) {
        // we should have less measures than maximum needed
        if (Number(measures.max) >= measuresCount) {
            maximumCheckPassed = true;
        }
    } else {
        maximumCheckPassed = true;
    }

    return minimumCheckPassed && maximumCheckPassed;
};
